import React from 'react';

const shimmerDelay = (ms) => ({'--shimmer-delay': `${ms}ms`});

function SkeletonContactRow({delay = 0}) {
    return (
        <div
            className="list-group-item px-0 py-3 border-bottom skeleton-item"
            style={{animationDelay: `${delay}ms`}}
        >
            <div className="d-flex justify-content-between align-items-start gap-3">
                <div className="flex-grow-1">
                    <span
                        className="skeleton-block mb-2 d-block"
                        style={{height: 16, width: '55%', ...shimmerDelay(delay + 80)}}
                    />
                    <span
                        className="skeleton-block d-block"
                        style={{height: 12, width: '40%', ...shimmerDelay(delay + 140)}}
                    />
                </div>
                <span
                    className="skeleton-block flex-shrink-0"
                    style={{height: 22, width: 88, borderRadius: '1rem', ...shimmerDelay(delay + 200)}}
                />
            </div>
        </div>
    );
}

function ConversationDetailsSkeleton({rows = 2}) {
    return (
        <div className="sms-skeleton list-group list-group-flush">
            {Array.from({length: rows}, (_, index) => (
                <SkeletonContactRow key={index} delay={index * 90}/>
            ))}
        </div>
    );
}

export default ConversationDetailsSkeleton;
